import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer } from "recharts";

/**
 * NovaCriteriaRadar — pequeño radar chart de los 6 criterios de un reto.
 * Props:
 *   score: { count, overall, per_criterion: {key: {avg, weight, n}} }
 *   criteria: [{key, label, weight}]
 *   height: default 220
 */
export default function NovaCriteriaRadar({ score, criteria, height = 220 }) {
  if (!score || !score.count) return null;
  const data = (criteria || []).map((c) => ({
    subject: c.label,
    avg: Number(score.per_criterion?.[c.key]?.avg || 0),
    fullMark: 5,
  }));
  if (!data.length) return null;

  return (
    <div className="w-full" data-testid="criteria-radar">
      <ResponsiveContainer width="100%" height={height}>
        <RadarChart data={data} outerRadius="70%">
          <PolarGrid stroke="#cbd5e1" />
          <PolarAngleAxis dataKey="subject" tick={{ fontSize: 10, fill: "#475569" }} />
          <PolarRadiusAxis angle={90} domain={[0, 5]} tick={{ fontSize: 9, fill: "#94a3b8" }} tickCount={6} />
          <Radar name="Media comité" dataKey="avg" stroke="#10b981" fill="#10b981" fillOpacity={0.35} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
